import React from 'react';

import StepTitle from '@vlabs/shared/legacy-components/steps/StepTitle';
import { Step } from '@vlabs/uikit';
import i18next from 'i18next';

import { CommonSubForm } from '../forms';
import st from './VerifierStep.module.sass';

const StepNameOfVerifier = () => {
  return (
    <Step
      className={st.Step}
      title={(
        <StepTitle>
          {i18next.t('verifiers:form.stepTitles.step1')}
        </StepTitle>
      )}
    >
      <CommonSubForm />
    </Step>
  );
};

StepNameOfVerifier.fieldNames = [
  'description',
  'verificationThreshold',
];

export { StepNameOfVerifier };
